import { useState } from "react";

/**
 * Modales apilados con "‹ Volver" de VARIOS niveles (Subscriptions solo guarda
 * uno): lista → ficha → otra ficha → volver, volver.
 */
const useModalStack = () => {
  const [stack, setStack] = useState([]);
  return {
    current: stack[stack.length - 1] ?? null,
    canGoBack: stack.length > 1,
    open: (modal) => setStack([modal]),
    push: (modal) => setStack((s) => [...s, modal]),
    back: () => setStack((s) => s.slice(0, -1)),
    close: () => setStack([]),
    replace: (modal) => setStack((s) => [...s.slice(0, -1), modal]),
  };
};

export default useModalStack;
